import { Icon } from "@biom3/react";
import DiamondIcon from "@mui/icons-material/Diamond";
import { Chip, Stack, type SxProps, Typography } from "@mui/material";

interface RewardsChipProps {
  completed?: boolean;
  amount: number;
  rewardType?: string;
  sx?: SxProps;
}

export const RewardsChip = ({
  completed,
  amount,
  rewardType = "gem",
  sx,
}: RewardsChipProps) => {
  const formattedAmount = amount >= 0 ? `+ ${amount}` : `- ${-amount}`;

  return (
    <Chip
      size="small"
      label={
        <Stack direction="row" alignItems="center" spacing={0.5}>
          <Typography variant="body2">{formattedAmount}</Typography>
          {rewardType === "campaign_point" ? (
            <Icon
              icon="Sparkle"
              variant="bold"
              sx={{ width: "16px", height: "16px", fill: "currentColor" }}
            />
          ) : (
            <DiamondIcon sx={{ fontSize: 16 }} />
          )}
        </Stack>
      }
      color={completed ? "success" : "secondary"}
      sx={sx}
    />
  );
};
